export default () => { 
  return {
    mono: 3000,
    day: 1200,
    night: 1800,
    gas: 17000,
    exclusiveNight: 3000,
    injectionBase: 0,
    injectionDay: 0,
    injectionNight: 0
  }
}


// WEBPACK FOOTER //
// ./src/mixins/averageConsumption.js